import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import RegionsCard from './RegionsCard';

const useStyles = makeStyles(theme => ({
  root: {
    margin: '66px auto 0',
    display: 'flex',
    justifyContent: 'center',
    width: 400,
    [theme.breakpoints.down('600')]: {
      width: '100%',
      margin: '26px auto 0',
    },
  },
}));

const Regions = ({ data }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {data.map((el, index) => (
        <RegionsCard data={el} key={index} />
      ))}
    </div>
  );
};

Regions.propTypes = {
  data: PropTypes.array,
};

export default Regions;
